import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import EmailConfigurationTableContainer from '../containers/emailConfiguration-table.container';
import EmailConfigurationDetailsContainer from '../containers/emailConfiguration-details.container';
import EmailConfigurationCreateContainer from '../containers/emailConfiguration-create.container';
import EmailConfigurationUpdateContainer from '../containers/emailConfiguration-update.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';

// Helper function to add default query parameters to the emailConfiguration list page
const EmailConfigurationListWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <EmailConfigurationTableContainer />;
};

export const emailConfigurationRoutes = [
  {
    path: 'admin/emailConfiguration/',
    element: <EmailConfigurationListWithParams />,
  },
  {
    path: 'admin/emailConfiguration/create',
    element: <EmailConfigurationCreateContainer />,
  },
  {
    path: 'admin/emailConfiguration/:id',
    element: <EmailConfigurationDetailsContainer />,
  },
  {
    path: 'admin/emailConfiguration/:id/update',
    element: <EmailConfigurationUpdateContainer />,
  },
];

export default emailConfigurationRoutes;
